import styles from './SearchInput.module.scss';

interface SearchInputProps {
  placeholder?: string;
  onSearch?: (query: string) => void;
  value?: string;
}

export function SearchInput(props: SearchInputProps) {
  const { placeholder = 'Search', onSearch, value } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;

    if (onSearch) {
      onSearch(query);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.searchIcon} />
      <input type="text" placeholder={placeholder} onChange={handleChange} value={value} />
    </div>
  );
}
